/**
 * Firebase Provider 组件
 * 在应用启动时初始化 Firebase
 */

'use client';

import { useEffect } from 'react';
import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { firebaseConfig } from './config';
import { usePathname } from 'next/navigation';

// // Firebase 配置
// const firebaseConfig = {
//   apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
//   authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
//   measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
// };

interface FirebaseProviderProps {
  children: React.ReactNode;
}

export function FirebaseProvider({ children }: FirebaseProviderProps) {
  const pathname = usePathname();
  useEffect(() => {
    // 检查是否已配置 Firebase
    if (!firebaseConfig.apiKey) {
      console.log('[Firebase] No API key configured, skipping initialization');
      return;
    }

    try {
      // 初始化 Firebase
      const app = getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig);

      // 初始化 Analytics（仅在浏览器环境）
      if (typeof window !== 'undefined') {
        const analytics = getAnalytics(app);

        // 记录页面访问事件
        logEvent(analytics, 'page_view', {
          page_title: document.title,
          page_location: window.location.href,
        });

        console.log('[Firebase] Initialized successfully');
      }
    } catch (error) {
      console.error('[Firebase] Initialization error:', error);
    }
  }, [pathname]);

  return <>{children}</>;
}
